import ApiDocumentSearchCard from './ApiDocumentSearchCard';

const CHANGE_STATUS_ACTIVE = '1';
const CHANGE_STATUS_CANCELED = '0';

const RELATION_COMPARISON_WITH_NEW = '1.21';
const RELATION_COMPARISON_WITH_OLD = '1.20';
const RELATION_INCLUDED_IN_CHECKLISTS = '1.5';
const RELATION_INSTEAD = '1.10';
const RELATION_REFERS_FROM = '1.1';
const RELATION_REFERS_TO = '1.0';
const RELATION_REPLACED = '1.11';
const RELATION_CHANGE_TO = '1.101';

/**
 * Полная карточка документа.
 *
 * @property {boolean} isChange
 * @property {string|null} parentDocumentId
 * @property {string} parentDocumentTitle
 * @property {Array<string>} statusHistory
 * @property {Array<string>} approvedText
 * @property {Array<string>} agreed
 * @property {Array<string>} authors
 * @property {Object<string,Array<ApiDocumentRelation>>|null} relations
 * @property {Array<string>} publications
 * @property {Array<ApiProgramItem>} programs
 * @property {string} comment
 * @property {ApiDocumentProject|null} project
 * @property {ApiDocumentDiscussion|null} discussion
 * @property {string|null} newDiscussionUrl
 * @property {string} normacsUrl
 * @property {Array<ApiDocumentCustomFieldsGroup>} customFields
 * @property {string|null} dbCreationDate
 * @property {string|null} dbUpdateDate
 * @property {string} accessComment
 */
export default class ApiDocumentCard extends ApiDocumentSearchCard {
  constructor(props) {
    super(props);
  }

  /**
   * @param {Array<{icon: string}>} statuses
   * @returns {string|null}
   */
  getStatusIcon(statuses) {
    if (this.isChange) {
      return null;
    }
    return super.getStatusIcon(statuses);
  }

  /**
   * @param {Array<{name: string}>} statuses
   * @returns {string|null}
   */
  getStatusName(statuses) {
    if (this.isChange) {
      return this.statusId === CHANGE_STATUS_CANCELED ? 'Отменено' : '';
    }
    return super.getStatusName(statuses);
  }

  /**
   * Возвращает значение true, если это отменный документ-изменение.
   * Для обычных документов и действующих документов-изменений
   * возвращает значение false.
   *
   * @returns {boolean}
   */
  isChangeCanceled() {
    return this.isChange && this.statusId === CHANGE_STATUS_CANCELED;
  }

  /**
   * Возвращает связанные документы для типа связи relationType.
   *
   * @param {string} relationType
   * @returns {Array<ApiDocumentRelation>}
   * @throws Error
   */
  getRelation(relationType) {
    if (this.relations) {
      return this.relations[relationType] || [];
    }
    throw new Error('Relations not set.');
  }

  /**
   * Возвращает документы, в которых содержится сравнение
   * этого документа с более новым документом.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationComparisonWithNew() {
    return this.getRelation(RELATION_COMPARISON_WITH_NEW);
  }

  /**
   * Возвращает документы, в которых содержится сравнение
   * этого документа с более старым документом.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationComparisonWithOld() {
    return this.getRelation(RELATION_COMPARISON_WITH_OLD);
  }

  /**
   * Возвращает документы, которые заменены на этот документ.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationInstead() {
    return this.getRelation(RELATION_INSTEAD);
  }

  /**
   * Возвращает документы, которые ссылаются на этот документ.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationRefersFrom() {
    return this.getRelation(RELATION_REFERS_FROM);
  }

  /**
   * Возвращает документы, на которые ссылается этот документ.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationRefersTo() {
    return this.getRelation(RELATION_REFERS_TO);
  }

  /**
   * Возвращает документы, на которые заменен этот документ.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationReplaced() {
    return this.getRelation(RELATION_REPLACED);
  }

  /**
   * Возвращает документы, в которые документ вносит изменения.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
   getRelationChangedTo() {
    return this.getRelation(RELATION_CHANGE_TO);
  }

  /**
   * Возвращает перечни, в которые входит этот документ.
   *
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationIncludedInChecklists() {
    return this.getRelation(RELATION_INCLUDED_IN_CHECKLISTS);
  }

  /**
   * Возвращает ответы экспертов, которые ссылаются на этот документ.
   *
   * @param {string} dbExpertId
   * @returns {Array<ApiDocumentRelation>}
   */
  getRelationExpertAnswers(dbExpertId) {
    return this.getRelationRefersFrom().filter(
      item => item.dbId === dbExpertId
    );
  }
}
